const DOMAIN_REGEXP = /^((?!-))(xn--)?[a-z0-9][a-z0-9-_]{0,61}[a-z0-9]{0,1}\.(xn--)?([a-z0-9\-]{1,61}|[a-z0-9-]{1,30}\.[a-z]{2,})$/;

/**
 * Validates a provided string against valid domain regexp (incl. IDN support).
 *
 * @param {string} domain
 * @param {string[]} allowProtocols - list of possible protocols to be present in "domain" value
 * @return {boolean}
 */
export default (domain, allowProtocols = ['http', 'https']) => {
    if (typeof domain !== 'string') {
        return false;
    }

    let v = domain.trim();
    const removeProtocol = new RegExp('(' + allowProtocols.join('|') + ')://');

    v = v.replace(removeProtocol, '');

    return DOMAIN_REGEXP.test(v);
}
